import { VFC } from 'react'
import { PdfIcon } from 'src/assets/svgs'
import { Linkify } from 'src/components/Linkify'
import { Link } from 'src/elements/Link'
import { Message } from 'src/models/Message'
import styled from 'styled-components'
import { ContentDiv } from './styles'

export { Content }

const ContentComponent: VFC<{
  content: Message['content']
  deleted?: boolean
  setPreviewImage: (url: string) => void
  className?: string
}> = ({
  content: { text, imageSources, documents } = {},
  deleted,
  setPreviewImage,
  className,
}) => {
  return (
    <ContentDiv className={className}>
      {text && (
        <p>
          <Linkify>{text}</Linkify>
        </p>
      )}
      {!deleted && (
        <>
          {imageSources?.map(({ url, filename }) => (
            <button key={url} onClick={() => setPreviewImage(url)}>
              <img src={url} alt={filename} />
            </button>
          ))}
          {documents?.map(({ url, filename }) => (
            <Link key={url} href={url} target="_blank">
              <p>
                <PdfIcon />
                {filename}
              </p>
            </Link>
          ))}
        </>
      )}
    </ContentDiv>
  )
}

const Content = styled(ContentComponent)`
  p {
    overflow-wrap: anywhere;
  }
`
